// A slider restricted to a handful of discrete credit amounts (rather than
// a continuous range) — dragging jumps straight between milestones, so the
// step is deliberately coarse. The track keeps a fixed width regardless of
// how many milestones there are; the input itself moves over milestone
// *indices*, not credit values, since the values aren't evenly spaced.

interface CreditsSliderProps {
  value: number;
  onChange: (value: number) => void;
  milestones?: number[];
}

export const CREDIT_MILESTONES = [10, 100, 1000];

export function CreditsSlider({ value, onChange, milestones = CREDIT_MILESTONES }: CreditsSliderProps) {
  const lastIndex = milestones.length - 1;
  const index = Math.max(milestones.indexOf(value), 0);

  return (
    <>
      <div className="price-milestones">
        {milestones.map((m, i) => (
          <button
            key={m}
            type="button"
            className={`price-milestone ${value === m ? 'active' : ''}`}
            style={{ left: `${(i / lastIndex) * 100}%` }}
            onClick={() => onChange(m)}
          >
            {m}
          </button>
        ))}
      </div>
      <div className="price-slider-track">
        <div className="price-slider-fill" style={{ width: `${(index / lastIndex) * 100}%` }} />
        <input
          type="range"
          className="price-slider-input"
          min={0}
          max={lastIndex}
          step={1}
          value={index}
          onChange={(e) => onChange(milestones[Number(e.target.value)])}
          aria-label="Credits"
        />
      </div>
    </>
  );
}

export default CreditsSlider;
